import { createReducer } from '@reduxjs/toolkit'

import { AuthActionTypes } from '@store/auth'
import { indexById } from '@utils/groupBy'
import { fetchXMetrics, fetchXMetricsError, fetchXMetricsSuccess } from './actions'
import { IXMetrics, IXMetricsState } from './types'

const initialState: IXMetricsState = {
  isFetching: false,
  errors: undefined,
  xMetricsById: {},
  xMetricIdsByCampaignId: {},
  xMetricsSummaryByCampaignId: {},
}

const reducer = createReducer(initialState, (builder) => {
  builder
    .addCase(fetchXMetrics, (state) => {
      state.isFetching = true
    })
    .addCase(fetchXMetricsSuccess, (state, { payload }) => {
      const { campaignId, metrics } = payload

      state.errors = undefined
      state.isFetching = false

      state.xMetricsById = {
        ...state.xMetricsById,
        ...indexById(metrics.items, state.xMetricsById, 'submission_id'),
      }

      state.xMetricsSummaryByCampaignId = {
        ...state.xMetricsSummaryByCampaignId,
        [campaignId]: metrics.metadata,
      }

      state.xMetricIdsByCampaignId = {
        ...state.xMetricIdsByCampaignId,
        [campaignId]: metrics.items.map((metric: IXMetrics) => metric.submission_id),
      }
    })
    .addCase(fetchXMetricsError, (state, { payload }) => {
      state.isFetching = false
      state.errors = payload
    })
    .addMatcher(
      (action) => action.type === AuthActionTypes.SIGNOUT_SUCCESS,
      () => initialState,
    )
})

export { reducer as xMetricsReducer }
